import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { Log } from './models/admin';
import { FeedbackPayload, RequestPayload } from './types';
import helper from './helper';
import { Address } from './models/address';
import { IS_DEV } from './api';
const ENDPOINT = 'service/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  log: (
    payload: Record<string, boolean | string | number | null | undefined | any>
  ) => instance.post<ApiResponse<any>>(ENDPOINT + 'log/add/', payload, config),
  getLog: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', Log>>>(
      ENDPOINT + 'log/list/',
      payload,
      config
    ),
  feedback: (payload: FeedbackPayload) =>
    instance.post<ApiResponse<Paginated<'data', Log>>>(
      ENDPOINT + 'feedback/',
      payload,
      config
    ),
  getVars: (payload?: {
    keys: string;
    visibility_on?: 'both' | 'app' | 'web';
  }) =>
    instance.get<ApiResponse<{ key: string, value: string }[]>>(
      ENDPOINT + 'variables/get/' + helper.toQueryString(payload),
      config
    ),
  addVar: (payload: { key: string; value: string }) =>
    instance.post(ENDPOINT + 'variables/add/', payload, config),
  updateVar: (varId: string, payload: { value: string }) =>
    instance.put(
      ENDPOINT + `variables/update/${varId}/`,
      {
        ...payload,
        Visibility_on: 'both',
      },
      config
    ),
  removeVar: (varId: string) =>
    instance.delete(ENDPOINT + `variables/delete/${varId}/`, config),
  geoLocation: (lat: number, lng: number) => instance.get<ApiResponse<Address[]>>(ENDPOINT + `geolocate/${lat}/${lng}/`, config),
});
